export default {
    kh: 'Khmer',
    en: 'English'
};
